import { QuotesBlotter } from 'components/Blotters/Quotes/quotes-blotter';
import { OrdersBasketFormCount } from 'components/OrdersBasket/OrdersBasketFormCount';
import { WithSplitterNext } from 'components/shared/WithSplitterNext/WithSplitterNext';
import { FC } from 'react';
import { disableGlobalCursorStyles } from 'react-resizable-panels';

import { OrdersBasket } from '../OrdersBasket/OrdersBasket';

disableGlobalCursorStyles();

export interface ICentralStationProps {}

export const CentralStation: FC<ICentralStationProps> = () => {
  return (
    <WithSplitterNext
      primaryPanel={<QuotesBlotter />}
      secondaryPanel={<OrdersBasket isVisible={true} />}
      badgeContent={
        <div className="d-flex">
          <span className="fw-bold">Orders basket</span>
          <OrdersBasketFormCount />
        </div>
      }
    />
  );
};
